import BaseSvg, { Props } from '../BaseSvg'

const FlashOn: React.FC<Props> = (props) => (
  <BaseSvg className={props.className} {...props}>
    <path d="M0.166687 0.333496V7.66683H2.16669V13.6668L6.83335 5.66683H4.16669L6.16669 0.333496H0.166687Z" />
  </BaseSvg>
)

export default FlashOn
